import { call, put, select, takeLeading } from 'redux-saga/effects';
import {
    APPLICATION_DETAIL_FETCH,
    FETCH_APPLICATION_DETAIL_FINISH,
    SET_APPLICATION_DETAIL,
    SAVE_REMOTE_APPLICATION_DETAIL,
    RESET_APPLICATION_FORM_INITIAL_POST_DATA,
    SAVE_CTC_DETAIL,
    SAVE_CTI_DETAIL,
    SAVE_CTA_DETAIL,
    APPLICATION_DETAIL_REFRESH,
    UPDATE_REMOTE_APPLICATION_CUSTOM_DATA,
    REMOVE_SITE_POST_DATA,
    RETURN_TO_SITE,
    SEND_TO_COORDINATING_INVESTIGATOR,
    SUBMIT_APPLICATION_FORM,
    CREATE_AMENDMENT_FORM,
    SAVE_DELEGATION,
    CLEAR_UP_REDUX,
    CLEAR_APPLICATION_DETAIL,
    CREATE_CTC_CTI,
    EXPORT_SITE_INFO,
    CCO_RETURN_ACTION,
} from 'store/key';
import { produce, publish } from 'utility/general';
import api from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';
import { safeSaga } from 'store';
import { cloneDeep } from 'lodash';
import { mapContent } from 'store/system/reducer';

// key is the application id
const getInitialState = () => {
    return {};
};

function* getApplicationDetail(action) {
    const { id, isLoading = true } = action.payload;

    try {
        yield put({ type: SET_APPLICATION_DETAIL, payload: { isLoading, isError: false } });
        const response = yield call(api.application.getApplicationDetail, { id });
        let tempResult = response.data.result;
        if (tempResult?.declareInv?.length > 0) {
            const seenSiteInfoIds = new Set();
            const firstPIs = [];
            const noPIs = tempResult?.declareInv?.filter((entry) => entry.role !== 'Principal Investigator');
            const sortedDeclareInv =
                tempResult?.declareInv
                    ?.filter((entry) => entry.role === 'Principal Investigator')
                    ?.sort((a, b) => a?.id - b?.id) || [];
            sortedDeclareInv?.forEach((entry) => {
                if (entry.role === 'Principal Investigator' && !seenSiteInfoIds.has(entry.siteInfoId)) {
                    seenSiteInfoIds.add(entry.siteInfoId);
                    firstPIs.push(entry);
                }
            });
            tempResult.declareInv = firstPIs?.concat(noPIs);
        }
        yield put({ type: SET_APPLICATION_DETAIL, payload: { [id]: tempResult, isLoading: false } });
        return tempResult;
    } catch (error) {
        yield put({ type: SET_APPLICATION_DETAIL, payload: { isError: true, isLoading: false } });

        console.log('172001 reducer.js error', error.response.data);

        publish({
            topic: 'changePath',
            args: {
                route: '/',
            },
        });

        // if(error?.response?.data?.errorMessage === 'You do not have premission to access this form.'){

        // }
    }

    yield put({ type: FETCH_APPLICATION_DETAIL_FINISH });
}

export function* refreshApplicationDetail(action) {
    const { id, callback = () => null, final = () => null, onError = () => null } = action.payload;

    try {
        const applicationDetail = yield getApplicationDetail({
            payload: {
                id,
                isLoading: false,
            },
        });
        callback(applicationDetail);
        final();
        return applicationDetail;
    } catch (error) {
        onError(error);
        final();
        console.log('124119 reducer.js error', error);
        throw error;
    }
}

function* updateRemoteApplicationWithCustomData(action) {
    const {
        actionType,
        id,
        data,
        callback = () => null,
        siteInfoId = -1,
        final,
        onError = () => null,
    } = action.payload;

    try {
        yield put({ type: SET_APPLICATION_DETAIL, payload: { isError: false } });

        yield call(api.application.saveApplicationDetail, {
            id,
            data,
            action: 'save',
            actionType,
        });

        // re-fetch newest status of the application form
        yield refreshApplicationDetail({
            payload: { id },
        });

        if (siteInfoId !== -1) {
            yield put({
                type: REMOVE_SITE_POST_DATA,
                payload: {
                    siteInfoId: siteInfoId,
                    applicationFormId: id,
                },
            });
        }

        yield put({
            type: SET_APPLICATION_DETAIL,
            payload: {
                isLoading: false,
            },
        });

        callback?.();
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        console.log('144404 reducer.js error', error);
        // yield put({ type: SET_APPLICATION_DETAIL, payload: { isError: true, isLoading: false } });
        throw error;
    }
}

export function* saveApplicationForm(action) {
    const { id, tabType = '', callback = () => null, final, onError = () => null } = action.payload;

    try {
        yield saveRemoteApplicationData({
            payload: {
                id,
                tabType,
            },
        });

        const applicationDetail = yield refreshApplicationDetail({
            payload: {
                id,
            },
        });

        // clear post data when submission
        yield put({
            type: RESET_APPLICATION_FORM_INITIAL_POST_DATA,
        });

        callback(applicationDetail);
        final?.();

        return applicationDetail;
    } catch (error) {
        onError(error);
        final?.();
        console.log('115551 reducer.js error', error);
        throw error;
    }
}

export function* saveDelegation(action) {
    const { id, callback = () => null, final, onError = () => null, dataToUpdate } = action.payload;

    try {
        const { postData, deleteRequest, removeRequest } = dataToUpdate;
        const newPostData = produce(postData, (draft) => {
            Object.values(draft).forEach((item) => {
                item?.forEach?.((tableItem) => {
                    if (tableItem?.id?.startsWith?.('temp_')) {
                        delete tableItem.id;
                    }
                });
            });
        });

        yield call(api.application.saveDelegation, {
            id,
            data: {
                ...newPostData,
                deleteRequest: deleteRequest,
                removeRequest: removeRequest,
            },
        });
        callback?.();
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        console.log('144404 reducer.js error', error);
        // yield put({ type: SET_APPLICATION_DETAIL, payload: { isError: true, isLoading: false } });
        throw error;
    }
}

export function* saveRemoteApplicationData(action) {
    const { applicationDetailPostData, applicationDetail } = yield select();
    const { id, tabType, callback = () => null, final, onError = () => null } = action.payload;
    const { deleteRequest, removeRequest } = applicationDetailPostData;

    // if(applicationFormId != id){
    //     throw new Error('application detail post data is not match with reducer')
    // }
    try {
        yield put({ type: SET_APPLICATION_DETAIL, payload: { isError: false } });

        const newPostData = produce(applicationDetailPostData.postData, (draft) => {
            Object.values(draft).forEach((item) => {
                item?.forEach?.((tableItem) => {
                    if (tableItem?.id?.startsWith?.('temp_')) {
                        delete tableItem.id;
                    }
                });
            });
        });

        // don't know why undefined key is exist in the postData
        delete newPostData['undefined'];

        const actionType = tabType === 'hospital' ? 'site_info' : 'study_info';

        const response = yield call(api.application.saveApplicationDetail, {
            id,
            data: {
                ...newPostData,
                deleteRequest: deleteRequest,
                removeRequest: removeRequest,
            },
            action: 'save',
            actionType,
        });

        if (response.status === 400) {
            console.log(response);
        }

        yield put({
            type: SET_APPLICATION_DETAIL,
            payload: {
                isLoading: false,
            },
        });

        callback?.();
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        console.log('144404 reducer.js error', error);
        // yield put({ type: SET_APPLICATION_DETAIL, payload: { isError: true, isLoading: false } });
        throw error;
    }
}

function* createCtcAndCti(action) {
    // const { applicationDetailPostData } = yield select();
    const { data, callback = () => null } = action.payload;
    setGlobalLoading(true);
    try {
        yield call(api.approval.createCtcAndCti, data);

        callback?.();
    } catch (error) {
        console.log('create ctc/cti error:', error);
    }

    setGlobalLoading(false);
}

function* saveCTCDetail(action) {
    // const { applicationDetailPostData } = yield select();
    const { id, data, callback = () => null } = action.payload;
    try {
        setGlobalLoading(true);

        yield call(api.approval.saveCTCDetail, {
            id,
            data,
            action: 'save',
        });

        callback?.();
    } catch (error) {
        console.log('144404 reducer.js error', error);
    }

    setGlobalLoading(false);
}
function* saveCTADetail(action) {
    // const { applicationDetailPostData } = yield select();
    const { id, data, callback = () => null } = action.payload;
    try {
        setGlobalLoading(true);

        yield call(api.approval.saveCTADetail, {
            id,
            data,
            action: 'save',
        });

        callback?.();
    } catch (error) {
        console.log('144404 reducer.js error', error);
    }

    setGlobalLoading(false);
}

function* returnToSite(action) {
    const { applicationDetail } = yield select();
    const { siteInfoId, applicationFormId, final, callback, onError = () => null } = action.payload;

    try {
        yield call(api.application.saveApplicationDetail, {
            action: 'return',
            id: applicationFormId,
            data: {
                siteInfo: [
                    {
                        id: siteInfoId,
                    },
                ],
            },
        });

        // update site-info status to 2 (RETURNED);
        const index = applicationDetail[applicationFormId].siteInfo.findIndex((item) => item.id === siteInfoId);
        applicationDetail[applicationFormId].siteInfo[index].status = 2;
        yield put({ type: SET_APPLICATION_DETAIL, payload: cloneDeep(applicationDetail) });

        callback?.();
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        console.log('095214 reducer.js error', error);
        throw error;
    }
}

function* createAmendmentForm(action) {
    const { applicationFormId, callback, final, onError = () => null, amendmentType, amendId } = action.payload;

    try {
        const createResult = yield call(api.amendment.createAmendmentForm, {
            applicationFormId,
            amendmentType,
            amendId,
        });

        // yield put({ type: SAVE_REMOTE_APPLICATION_DETAIL, payload: { id: createResult.data.result } });

        callback?.(createResult.data.result);
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        console.log('105319 reducer.js error', error);
        throw error;
    }
}

function* submitApplication(action) {
    const { applicationDetailPostData } = yield select();
    const { postData } = applicationDetailPostData;
    const { applicationFormId, callback, final, requestData, onError = () => null } = action.payload;

    try {
        const applicationDetail = yield saveApplicationForm({
            payload: {
                id: applicationFormId,
                postData,
            },
        });

        // const applicationDetail = yield refreshApplicationDetail({ payload: { id: applicationFormId } });

        requestData.id = applicationFormId;
        requestData.data = { saveRequest: applicationDetail };

        yield call(api.application.saveApplicationDetail, requestData);

        yield refreshApplicationDetail({
            payload: {
                id: applicationFormId,
            },
        });

        callback?.();
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        console.log('105319 reducer.js error', error);
        throw error;
    }
}

function* sendToCoordinatingInvestigator(action) {
    const { applicationDetailPostData, user } = yield select();
    const { postData } = applicationDetailPostData;
    const {
        applicationFormId,
        siteInfoId,
        involvesSpecialCases = null,
        tabType,
        callback,
        final,
        onError = () => null,
    } = action.payload;
    try {
        yield saveApplicationForm({
            payload: {
                id: applicationFormId,
                tabType,
                postData,
            },
        });

        yield call(api.application.notifyCIForSubmissionApplication, {
            siteInfoId,
            applicationFormId,
            involvesSpecialCases: involvesSpecialCases?.length > 0 ? involvesSpecialCases === 'yes' : null,
            role: user.role,
        });

        yield refreshApplicationDetail({
            payload: {
                id: applicationFormId,
            },
        });

        callback?.();
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        console.log('100732 reducer.js error', error);
        throw error;
    }
}

function* saveCTIDetail(action) {
    // const { applicationDetailPostData } = yield select();
    const { id, data, callback = () => null } = action.payload;

    try {
        setGlobalLoading(true);
        yield call(api.approval.saveCTIDetail, {
            id,
            data,
            action: 'save',
        });

        callback?.();
    } catch (error) {
        console.log('144404 reducer.js error', error);
    }

    setGlobalLoading(false);
}

function* exportSiteInfo(action) {
    const { id, data, callback = () => null } = action.payload;
    try {
        setGlobalLoading(true);
        const resp = yield call(api.landing.exportSiteInfo, { data });
        mapContent(resp);
        callback?.();
    } catch (error) {
        console.log('exportSiteInfo: ', error);
    } finally {
        setGlobalLoading(false);
    }
}

function* ccoReturnAction(action) {
    const { applicationFormId, tabType, callback = () => null, final, onError = () => null, } = action.payload;
    const { applicationDetailPostData, applicationDetail } = yield select();
    const { deleteRequest, removeRequest } = applicationDetailPostData;

    const newPostData = produce(applicationDetailPostData.postData, (draft) => {
        Object.values(draft).forEach((item) => {
            item?.forEach?.((tableItem) => {
                if (tableItem?.id?.startsWith?.('temp_')) {
                    delete tableItem.id;
                }
            });
        });
    });
    delete newPostData['undefined'];

    try {
        const actionType = tabType === 'hospital' ? 'site_info' : 'study_info';
        yield call(api.application.saveApplicationDetail, {
            id: applicationFormId,
            data: {
                ...newPostData,
                deleteRequest: deleteRequest,
                removeRequest: removeRequest,
            },
            action: 'save',
            actionType,
        });
        const updatedData = yield refreshApplicationDetail({
            payload: {
                id: applicationFormId,
            },
        });

        const res = yield call(api.application.saveApplicationDetail, {
            id: applicationFormId,
            data: {
                saveRequest: updatedData,
            },
            action: 'returnToApplicant',
            // actionType,
        });
        if (res?.status === 200) {
            callback?.();
        }
        
        final?.();
    } catch (error) {
        onError(error);
        final?.();
        throw error;
    }
}

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_APPLICATION_DETAIL:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        case CLEAR_UP_REDUX:
            return getInitialState();
        case CLEAR_APPLICATION_DETAIL:
            return getInitialState();
        default:
            return state;
    }
};

export function* watchApplicationDetail() {
    yield takeLeading(APPLICATION_DETAIL_FETCH, safeSaga(getApplicationDetail));
    yield takeLeading(SAVE_REMOTE_APPLICATION_DETAIL, safeSaga(saveApplicationForm));
    yield takeLeading(SAVE_CTC_DETAIL, safeSaga(saveCTCDetail));
    yield takeLeading(SAVE_CTI_DETAIL, safeSaga(saveCTIDetail));
    yield takeLeading(SAVE_CTA_DETAIL, safeSaga(saveCTADetail));
    yield takeLeading(APPLICATION_DETAIL_REFRESH, safeSaga(refreshApplicationDetail));
    yield takeLeading(UPDATE_REMOTE_APPLICATION_CUSTOM_DATA, safeSaga(updateRemoteApplicationWithCustomData));
    yield takeLeading(RETURN_TO_SITE, safeSaga(returnToSite));
    yield takeLeading(SEND_TO_COORDINATING_INVESTIGATOR, safeSaga(sendToCoordinatingInvestigator));
    yield takeLeading(SUBMIT_APPLICATION_FORM, safeSaga(submitApplication));
    yield takeLeading(CREATE_AMENDMENT_FORM, safeSaga(createAmendmentForm));
    yield takeLeading(SAVE_DELEGATION, safeSaga(saveDelegation));
    yield takeLeading(CREATE_CTC_CTI, safeSaga(createCtcAndCti));
    yield takeLeading(EXPORT_SITE_INFO, safeSaga(exportSiteInfo));
    yield takeLeading(CCO_RETURN_ACTION, safeSaga(ccoReturnAction));
}

export default reducer;
